import React from 'react';
import { FailedQuotesContainer, FailedQuoteTitle } from '../../../../../screens/RcQuotes.styles';
import { BACKEND_BASE_URL } from '../../../../../config';

function FailedQuotationsComponent({ failedQuotes }) {
  return (
    <div className="mt-5">
      <FailedQuoteTitle>
        Queste compagnie non hanno risposto con una quotazione.
      </FailedQuoteTitle>
      <div className="d-flex align-items-center justify-content-start flex-wrap gap-3">
        {failedQuotes.map((quote, index) => (
          <div key={index}>
            <FailedQuotesContainer>
              <img
                src={BACKEND_BASE_URL + quote.company.logo}
                alt={`${quote.company.name} Logo`}
              />
            </FailedQuotesContainer>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FailedQuotationsComponent;
